<template>
  <el-dialog title="导出" :visible.sync="dialogVisible" custom-class="importDialog" :close-on-click-modal="false" :close-on-press-escape="false" v-loading="loading">
    <el-form :model="form" :rules="rules" ref="refDialog" label-width="100px">
      <el-form-item label="文件名" prop="filename">
        <el-input v-model="form.filename"></el-input>
      </el-form-item>

      <el-form-item label="备注">
        <el-input v-model="form.remark"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
// import { dealReturn } from "@/common/js/index.js";
export default {
  name: "ExportDialog",
  data() {
    return {
      dialogVisible: false,
      rules: {
        filename: [{ required: true, message: "必填项", trigger: "blur" }],
      },
      form: {}, // 后续需要跟多字段可以用上
      loading: false,
    };
  },
  methods: {
    show() {
      this.dialogVisible = true;
    },
    hide() {
      this.dialogVisible = false;
      this.form = {};
      this.$refs.refDialog.resetFields();
    },
    turnLoading(bool) {
      this.loading = bool;
    },
    async submit() {
      let isValid;
      this.$refs.refDialog.validate((valid) => {
        isValid = valid;
      });
      if (!isValid) {
        // this.$message.error("文件名必填");
        return;
      } else {
        // 向父组件派发事件
        this.$emit("submit", JSON.parse(JSON.stringify(this.form)));
      }
      // console.log("this", this);
    },
  },
};
</script>

<style lang="scss" scoped>
.el-dialog__wrapper >>> {
  .importDialog {
    width: 600px;
  }
}
</style>


// WEBPACK FOOTER //
// src/base/exportDialog/index.vue